import e from"../use-current-state";export default(t=!1)=>{const[r,n,s]=e(t);return{visible:r,setVisible:n,currentRef:s,bindings:{open:r,onClose:()=>n(!1)}}};